import { ILocalizationItem } from "@multiweb/types/contracts/localizations";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * Komunikační klient poskytuje přístup k lokalizovaným překladům textů
 * @includeToDoc
 */
export interface ILocalizationClient {

    /**
     * Získá lokalizované hodnoty pro požadované lokalizační klíče
     * @param language Jazyk lokalizace (např. 'EN' nebo 'CZ')
     * @param locKeys Pole lokalizačních klíčů obsahujících jak oblast, tak číslo (např. XX-12345)
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     * @returns Pole lokalizovaných hodnot
     */
    getLocalizations(language: string, locKeys: readonly string[], cancellationToken?: CancellationToken): Promise<readonly ILocalizationItem[]>;
}
